export const defaultMapCenter = { latitude: 36.13303, longitude: -96.03076 }; // 295 TULSA
export const defaultMapTheme = 'streets-navigation-vector';
export const defaultMapZoom = 7; // US State
export const defaultMapViewOptions = {
  highlightOptions: {
    color: [0, 0, 0, 0], // remove marker highlight
  },
  popup: {
    collapseEnabled: false, // allow tap on map markers in mobile
    dockOptions: {
      buttonEnabled: false, // remove popup dock button
    },
    viewModel: {
      includeDefaultActions: false, // remove popup zoomTo button
    },
    visibleElements: {
      closeButton: false, // remove popup close button
    },
  },
};
